import moment from "moment";
import { MetricsList, dimensionNameObj, metricsNameObj } from "../components/MainContent/AdvancedCustomChart/MetricsList";
import { getSentimentColor, intToRGB, hashCode, getPlatformColorCode, getEntityColor, toTitleCase } from "../components/MainContent/Dashboard/Charts/utils";
import { ProductAttributes } from "../components/MainContent/Dashboard/ProductAttributeValues";
import { getCorrectedDate } from "../actions/dashboardActionUtils";
// import store from "../store";

const post_types_names = {
    0: "Only Post",
    1: "Comment/ Replies",
    2: "Retweet",
    3: "LexisNexis Online Post",
    4: "LexisNexis Offline Post",
    5: "Quoted Retweet",
};

export const multiMetricFormation = (metric) => {
    let masterFilterData = metric[2];
    let LegendLabel = MetricsList.metrics.filter((ele) => ele.label == metric[0].payload[1].metric_name);
    let LegendLabel1 = MetricsList.metrics.filter((ele) => ele.label == metric[1].payload[1].metric_name);
    const topicsObject = metric[3];
    let momentsMeta = metric[0].payload[2];
    let paramsData = metric[0].payload[3];
    let tz = metric[0].payload[4];

    console.log("firstmetric 11111", paramsData);
    const isChecked = metric[4];
    const viewCountCheckbox = isChecked?.[metric[0]?.widgetId] || false;
    // console.log("hheeer am iiii",isChecked,"isChecked",isChecked?.widgetId )
    let subtopicObject = {};
    for (let key in topicsObject) {
        let topicSubtopic = topicsObject[key].subtopics;
        topicSubtopic.forEach((ele) => {
            subtopicObject[ele.subtopic_id] = {
                subtopic_name: ele.subtopic_name,
                subtopic_color: ele.subtopic_graph_color,
                subtopic_topic_name: ele.topic_name,
            };
        });
    }
    const ret = {
        data: [],
        maximizeData: [],
        csvData: {
            data: [],
        },
        nodata: false,
    };
    const result = {
        leftYAxis: {
            name: LegendLabel[0].value,
            // type: "column",
            stack: "test",
            yAxis: 1,
            data: [],
            lineData: [],
        },
        rightYAxis: {
            name: LegendLabel1[0].value,
            // type: "column",
            data: [],
            lineData: [],
        },
        nodata: false,
    };
    let totalDataCount = 0;
    try {
        const allowedKeys = ["male", "female", "person", "non-person", "brand", "news"];
        // format 1D 2M
        if (metric[0].payload[1].breakdown_dimension_name == "") {
            if (["topics_data", "sub_topics_data"].includes(metric[0].payload[1]?.dimension_name)) {
                metric[0].payload[0].forEach((ele) => {
                    if (metric[0].payload[1]?.dimension_name === "topics_data") {
                        let obj = {};
                        obj.name = ele.topic_name;
                        obj.dataId = ele.topic_id;

                        if (metric[0].payload[1].metric_name === "mention") {
                            obj.y = ele.total;
                        } else if (metric[0].payload[1].metric_name === "enagagment_value") {
                            if (viewCountCheckbox) {
                                // console.log("zoro",viewCountCheckbox,ele.aggregations?.view_count.sum);
                                obj.y = ele.aggregations?.comment_count.sum + ele.aggregations?.like_count.sum + ele.aggregations?.share_count.sum;
                            } else {
                                // console.log("zoro",viewCountCheckbox,ele.aggregations?.view_count.sum);
                                obj.y =
                                    ele.aggregations?.view_count.sum +
                                    ele.aggregations?.comment_count.sum +
                                    ele.aggregations?.like_count.sum +
                                    ele.aggregations?.share_count.sum;
                            }
                        } else if (metric[0].payload[1].metric_name === "unique_user") {
                            obj.y = ele.aggregations?.[metric[0].payload[1].metric_name].value;
                        } else if (metric[0].payload[1].metric_name === "sentiment") {
                            obj.y = parseFloat(advancedNetSentimentMetric(ele.aggregations.sentiments.group1.group2.buckets).toFixed(2));
                        } else {
                            obj.y = ele.aggregations?.[metric[0].payload[1].metric_name].sum;
                        }

                        // obj.color = topicsObject[ele.topic_id].color;
                        obj.dimensionName = metric[0].payload[1]?.dimension_name;
                        obj.yAxisName = metricsNameObj[metric[0].payload[1].metric_name] || metric[0].payload[1].metric_name;

                        totalDataCount += obj.y || 0;
                        result.leftYAxis.data.push(JSON.parse(JSON.stringify(obj)));
                    } else {
                        ele.subtopics?.forEach((subtopicsObj) => {
                            // console.log("c3fj2", subtopicsObj);

                            let obj = {};

                            obj.name = subtopicsObj.subtopic_name + "(" + `${subtopicObject[subtopicsObj.subtopic_id].subtopic_topic_name}` + ")";
                            obj.dataId = subtopicsObj.subtopic_id;

                            if (metric[0].payload[1].metric_name === "mention") {
                                obj.y = subtopicsObj.total;
                            } else if (metric[0].payload[1].metric_name === "enagagment_value") {
                                if (viewCountCheckbox) {
                                    // console.log("zoro",viewCountCheckbox,subtopicsObj.aggregations?.view_count.sum);
                                    obj.y =
                                        subtopicsObj.aggregations?.comment_count.sum +
                                        subtopicsObj.aggregations?.like_count.sum +
                                        subtopicsObj.aggregations?.share_count.sum;
                                } else {
                                    // console.log("zoro",viewCountCheckbox,subtopicsObj.aggregations?.view_count.sum);
                                    obj.y =
                                        subtopicsObj.aggregations?.view_count.sum +
                                        subtopicsObj.aggregations?.comment_count.sum +
                                        subtopicsObj.aggregations?.like_count.sum +
                                        subtopicsObj.aggregations?.share_count.sum;
                                }
                            } else if (metric[0].payload[1].metric_name === "unique_user") {
                                obj.y = subtopicsObj.aggregations?.[metric[0].payload[1].metric_name].value;
                            } else if (metric[0].payload[1].metric_name === "sentiment") {
                                obj.y = parseFloat(advancedNetSentimentMetric(subtopicsObj.aggregations?.sentiments?.group1?.group2?.buckets).toFixed(2));
                            } else {
                                obj.y = subtopicsObj.aggregations?.[metric[0].payload[1].metric_name].sum;
                            }
                            // obj.color = subtopicObject[subtopicsObj.subtopic_id].subtopic_color || "#FF0000";
                            obj.dimensionName = metric[0].payload[1]?.dimension_name;
                            obj.yAxisName = metricsNameObj[metric[0].payload[1].metric_name] || metric[0].payload[1].metric_name;
                            totalDataCount += obj.y || 0;
                            result.leftYAxis.data.push(JSON.parse(JSON.stringify(obj)));
                        });
                    }
                    // console.log("obj.name 2222", obj);
                });

                metric[1].payload[0].forEach((ele) => {
                    if (metric[1].payload[1]?.dimension_name === "topics_data") {
                        let obj = {};

                        obj.name = ele.topic_name;
                        obj.dataId = ele.topic_id;
                        if (metric[1].payload[1].metric_name === "mention") {
                            // obj.y = ele.aggregations?.doc_count;
                            obj.y = ele.total;
                        } else if (metric[1].payload[1].metric_name === "enagagment_value") {
                            if (viewCountCheckbox) {
                                // console.log("zoro",viewCountCheckbox,ele.aggregations?.view_count.sum);
                                obj.y = ele.aggregations?.comment_count.sum + ele.aggregations?.like_count.sum + ele.aggregations?.share_count.sum;
                            } else {
                                // console.log("zoro",viewCountCheckbox,ele.aggregations?.view_count.sum);
                                obj.y =
                                    ele.aggregations?.view_count.sum +
                                    ele.aggregations?.comment_count.sum +
                                    ele.aggregations?.like_count.sum +
                                    ele.aggregations?.share_count.sum;
                            }
                        } else if (metric[1].payload[1].metric_name === "unique_user") {
                            obj.y = ele.aggregations?.[metric[1].payload[1].metric_name].value;
                        } else if (metric[1].payload[1].metric_name === "sentiment") {
                            obj.y = parseFloat(advancedNetSentimentMetric(ele.aggregations.sentiments.group1.group2.buckets).toFixed(2));
                        } else {
                            obj.y = ele.aggregations?.[metric[1].payload[1].metric_name].sum;
                        }
                        totalDataCount += obj.y || 0;
                        // obj.color = topicsObject[ele.topic_id].color;
                        obj.yAxisName = metricsNameObj[metric[1].payload[1].metric_name] || metric[1].payload[1].metric_name;
                        obj.dimensionName = metric[1].payload[1].dimension_name;

                        result.rightYAxis.data.push(JSON.parse(JSON.stringify(obj)));
                    } else {
                        ele.subtopics?.forEach((subtopicsObj) => {
                            let obj = {};

                            obj.name = subtopicsObj.subtopic_name + "(" + `${subtopicObject[subtopicsObj.subtopic_id].subtopic_topic_name}` + ")";
                            obj.dataId = subtopicsObj.subtopic_id;

                            if (metric[1].payload[1].metric_name === "mention") {
                                obj.y = subtopicsObj.total;
                            } else if (metric[1].payload[1].metric_name === "enagagment_value") {
                                if (viewCountCheckbox) {
                                    // console.log("zoro",viewCountCheckbox,subtopicsObj.aggregations?.view_count.sum);
                                    obj.y =
                                        subtopicsObj.aggregations?.comment_count.sum +
                                        subtopicsObj.aggregations?.like_count.sum +
                                        subtopicsObj.aggregations?.share_count.sum;
                                } else {
                                    // console.log("zoro",viewCountCheckbox,subtopicsObj.aggregations?.view_count.sum);
                                    obj.y =
                                        subtopicsObj.aggregations?.view_count.sum +
                                        subtopicsObj.aggregations?.comment_count.sum +
                                        subtopicsObj.aggregations?.like_count.sum +
                                        subtopicsObj.aggregations?.share_count.sum;
                                }
                            } else if (metric[1].payload[1].metric_name === "unique_user") {
                                obj.y = subtopicsObj.aggregations?.[metric[1].payload[1].metric_name].value;
                            } else if (metric[1].payload[1].metric_name === "sentiment") {
                                obj.y = parseFloat(advancedNetSentimentMetric(subtopicsObj.aggregations.sentiments.group1.group2.buckets).toFixed(2));
                            } else {
                                obj.y = subtopicsObj.aggregations?.[metric[1].payload[1].metric_name].sum;
                            }
                            totalDataCount += obj.y || 0;
                            // obj.color = subtopicObject[subtopicsObj.subtopic_id].subtopic_color || "#FF0000";
                            obj.dimensionName = metric[1].payload[1].dimension_name;
                            obj.yAxisName = metricsNameObj[metric[1].payload[1].metric_name] || metric[1].payload[1].metric_name;

                            result.rightYAxis.data.push(JSON.parse(JSON.stringify(obj)));
                        });
                    }
                });
            } else {
                if (metric[0].payload[1].dimension_name === "entity_sub_type" || metric[0].payload[1].dimension_name === "entity_types") {
                    metric[0].payload[0] = metric[0].payload[0]?.filter((obj) => {
                        return allowedKeys.includes(obj.key);
                    });
                    metric[1].payload[0] = metric[1].payload[0]?.filter((obj) => {
                        return allowedKeys.includes(obj.key);
                    });
                }

                metric[0].payload[0].forEach((ele) => {
                    let obj = {};
                    obj.dimensionName = metric[0].payload[1].dimension_name;
                    obj.metricName = metric[0].payload[1].metric_name;

                    switch (metric[0].payload[1].dimension_name) {
                        case "published_date":
                            // obj.name = ele.key_as_string;
                            obj.name = moment(ele.key_as_string).format("YYYY-MM-DD");
                            if (moment(paramsData.start_date).isAfter(moment(ele.key).tz(tz).format("YYYY-MM-DDTHH:mm:ss")))
                                obj.dataId = getCorrectedDate(paramsData, ele.key);
                            else obj.dataId = ele.key;
                            break;

                        case "post_types":
                            obj.name = post_types_names[ele.key];
                            obj.dataId = ele.key;
                            break;

                        case "platforms": {
                            obj.name = ele.key;
                            let platformObj = masterFilterData.masterPlatforms.find((obj) => obj.name === ele.key);
                            obj.dataId = platformObj?.id;
                            // obj.color = getPlatformColorCode(ele.key);
                            break;
                        }

                        case "countries": {
                            obj.name = ele.key;
                            let countryObj = masterFilterData.masterLocations.find((obj) => obj.name === ele.key);
                            obj.dataId = countryObj?.id;
                            break;
                        }

                        case "languages": {
                            obj.name = ele.key;
                            let langObj = masterFilterData.masterLanguages.find((obj) => obj.name === ele.key);
                            obj.dataId = langObj?.id;
                            break;
                        }

                        case "sentiments": {
                            obj.name = toTitleCase(ele.key);
                            obj.dataId = ele.key;
                            // obj.color = getSentimentColor(ele.key.toLowerCase());
                            break;
                        }

                        case "entity_sub_type": {
                            obj.name = toTitleCase(ele.key);
                            obj.dataId = ele.key;
                            // obj.color = getEntityColor(ele.key.toLowerCase());
                            break;
                        }

                        case "entity_types": {
                            obj.name = toTitleCase(ele.key);
                            obj.dataId = ele.key;
                            // obj.color = getEntityColor(ele.key.toLowerCase());
                            break;
                        }

                        case "product_attributes": {
                            let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === ele.key);
                            obj.name = ProductAttributesName[0]?.attributeName || ele.key;
                            obj.dataId = ele.key;
                            // obj.color = intToRGB(hashCode(ProductAttributesName[0]?.attributeName || ele.key));
                            break;
                        }

                        case "moments":
                            obj.dataId = ele.key;
                            obj.name = momentsMeta.find((elem) => elem.id === ele.key)?.name || ele.key;
                            // obj.color = intToRGB(hashCode(obj.name));
                            break;

                        case "top_influencers":
                            obj.name = ele.user_latest_post.hits.hits[0]._source.post_author.name;
                            obj.dataId = ele.key;
                            break;

                        default:
                            obj.name = ele.key;
                            obj.dataId = ele.key;
                        // obj.color = intToRGB(hashCode(ele.key));
                    }
                    if (metric[0].payload[1].dimension_name !== "sentiments") {
                        if (metric[0].payload[1].metric_name === "mention") {
                            obj.y = ele.doc_count;
                        } else if (metric[0].payload[1].metric_name === "enagagment_value") {
                            if (viewCountCheckbox) {
                                // console.log("zoro",viewCountCheckbox,ele.view_count.sum);
                                obj.y = ele.comment_count.sum + ele.like_count.sum + ele.share_count.sum;
                            } else {
                                // console.log("zoro",viewCountCheckbox,ele.view_count.sum);
                                obj.y = ele.view_count.sum + ele.comment_count.sum + ele.like_count.sum + ele.share_count.sum;
                            }
                        } else if (metric[0].payload[1].metric_name === "unique_user") {
                            obj.y = ele[metric[0].payload[1].metric_name].value;
                        } else if (metric[0].payload[1].metric_name === "sentiment") {
                            obj.y = parseFloat(advancedNetSentimentMetric(ele.sentiments.group1.group2.buckets).toFixed(2));
                        } else {
                            obj.y = ele[metric[0].payload[1].metric_name].sum;
                        }
                    } else {
                        if (metric[0].payload[1].metric_name === "mention") {
                            obj.y = ele.doc_count;
                        } else if (metric[0].payload[1].metric_name === "enagagment_value") {
                            if (viewCountCheckbox) {
                                // console.log("zoro",viewCountCheckbox,ele[metric[0].payload[1].metric_name].view_count.sum);
                                obj.y =
                                    ele[metric[0].payload[1].metric_name].comment_count.sum +
                                    ele[metric[0].payload[1].metric_name].like_count.sum +
                                    ele[metric[0].payload[1].metric_name].share_count.sum;
                            } else {
                                // console.log("zoro",viewCountCheckbox,ele[metric[0].payload[1].metric_name].view_count.sum);
                                obj.y =
                                    ele[metric[0].payload[1].metric_name].view_count.sum +
                                    ele[metric[0].payload[1].metric_name].comment_count.sum +
                                    ele[metric[0].payload[1].metric_name].like_count.sum +
                                    ele[metric[0].payload[1].metric_name].share_count.sum;
                            }
                        } else if (metric[0].payload[1].metric_name === "unique_user") {
                            obj.y = ele[metric[0].payload[1].metric_name][metric[0].payload[1].metric_name].value;
                        } else if (metric[0].payload[1].metric_name === "sentiment") {
                            obj.y = parseFloat(advancedNetSentimentMetric(ele[metric[0].payload[1].metric_name].sentiments.group1.group2.buckets).toFixed(2));
                        } else {
                            obj.y = ele[metric[0].payload[1].metric_name][metric[0].payload[1].metric_name].sum;
                        }
                    }

                    totalDataCount += obj.y || 0;
                    let metricsVal = metricsNameObj[metric[0].payload[1].metric_name] || metric[1].payload[1].metric_name;
                    obj.yAxisName = metricsVal;
                    result.leftYAxis.data.push(JSON.parse(JSON.stringify(obj)));
                });
                metric[1].payload[0].forEach((ele) => {
                    let obj = {};
                    obj.dimensionName = metric[1].payload[1].dimension_name;
                    obj.metricName = metric[1].payload[1].metric_name;

                    switch (metric[1].payload[1].dimension_name) {
                        case "published_date":
                            // obj.name = ele.key_as_string;
                            obj.name = moment(ele.key_as_string).format("YYYY-MM-DD");
                            if (moment(paramsData.start_date).isAfter(moment(ele.key).tz(tz).format("YYYY-MM-DDTHH:mm:ss")))
                                obj.dataId = getCorrectedDate(paramsData, ele.key);
                            else obj.dataId = ele.key;
                            break;
                        case "post_types":
                            obj.name = post_types_names[ele.key];
                            obj.dataId = ele.key;
                            break;

                        case "platforms": {
                            obj.name = ele.key;
                            let platformObj = masterFilterData.masterPlatforms.find((obj) => obj.name === ele.key);
                            obj.dataId = platformObj?.id;
                            // obj.color = getPlatformColorCode(ele.key);
                            break;
                        }

                        case "countries": {
                            obj.name = ele.key;
                            let countryObj = masterFilterData.masterLocations.find((obj) => obj.name === ele.key);
                            obj.dataId = countryObj?.id;
                            break;
                        }

                        case "languages": {
                            obj.name = ele.key;
                            let langObj = masterFilterData.masterLanguages.find((obj) => obj.name === ele.key);
                            obj.dataId = langObj?.id;
                            break;
                        }

                        case "sentiments": {
                            obj.name = toTitleCase(ele.key || "");
                            obj.dataId = ele.key;
                            // obj.color = getSentimentColor(ele.key.toLowerCase());
                            break;
                        }
                        case "entity_sub_type": {
                            obj.name = toTitleCase(ele.key);
                            obj.dataId = ele.key;
                            // obj.color = getEntityColor(ele.key.toLowerCase());
                            break;
                        }

                        case "entity_types": {
                            obj.name = toTitleCase(ele.key);
                            obj.dataId = ele.key;
                            // obj.color = getEntityColor(ele.key.toLowerCase());
                            break;
                        }

                        case "product_attributes": {
                            let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === ele.key);
                            obj.name = ProductAttributesName[0]?.attributeName || ele.key;
                            obj.dataId = ele.key;
                            // obj.color = intToRGB(hashCode(ProductAttributesName[0]?.attributeName || ele.key));
                            break;
                        }

                        case "moments":
                            obj.dataId = ele.key;
                            obj.name = momentsMeta.find((elem) => elem.id === ele.key)?.name || ele.key;
                            // obj.color = intToRGB(hashCode(obj.name));
                            break;

                        case "top_influencers":
                            obj.name = ele.user_latest_post.hits.hits[0]._source.post_author.name;
                            obj.dataId = ele.key;
                            break;

                        default:
                            obj.name = ele.key;
                            obj.dataId = ele.key;
                        // obj.color = intToRGB(hashCode(ele.key));
                    }

                    if (metric[1].payload[1].dimension_name !== "sentiments") {
                        if (metric[1].payload[1].metric_name === "mention") {
                            obj.y = ele.doc_count;
                        } else if (metric[1].payload[1].metric_name === "enagagment_value") {
                            if (viewCountCheckbox) {
                                // console.log("zoro",viewCountCheckbox,ele.view_count.sum);
                                obj.y = ele.comment_count.sum + ele.like_count.sum + ele.share_count.sum;
                            } else {
                                // console.log("zoro",viewCountCheckbox,ele.view_count.sum);
                                obj.y = ele.view_count.sum + ele.comment_count.sum + ele.like_count.sum + ele.share_count.sum;
                            }
                        } else if (metric[1].payload[1].metric_name === "unique_user") {
                            obj.y = ele[metric[1].payload[1].metric_name].value;
                        } else if (metric[1].payload[1].metric_name === "sentiment") {
                            obj.y = parseFloat(advancedNetSentimentMetric(ele.sentiments.group1.group2.buckets).toFixed(2));
                        } else {
                            // console.log("sdfsdfd",ele,ele[metric[1].payload[1].metric_name])
                            obj.y = ele[metric[1].payload[1].metric_name].sum;
                        }
                    } else {
                        if (metric[1].payload[1].metric_name === "mention") {
                            obj.y = ele.doc_count;
                        } else if (metric[1].payload[1].metric_name === "enagagment_value") {
                            if (viewCountCheckbox) {
                                // console.log("zoro",viewCountCheckbox,ele[metric[1].payload[1].metric_name].view_count.sum);
                                obj.y =
                                    ele[metric[1].payload[1].metric_name].comment_count.sum +
                                    ele[metric[1].payload[1].metric_name].like_count.sum +
                                    ele[metric[1].payload[1].metric_name].share_count.sum;
                            } else {
                                // console.log("zoro",viewCountCheckbox,ele[metric[1].payload[1].metric_name].view_count.sum);
                                obj.y =
                                    ele[metric[1].payload[1].metric_name].view_count.sum +
                                    ele[metric[1].payload[1].metric_name].comment_count.sum +
                                    ele[metric[1].payload[1].metric_name].like_count.sum +
                                    ele[metric[1].payload[1].metric_name].share_count.sum;
                            }
                        } else if (metric[1].payload[1].metric_name === "unique_user") {
                            obj.y = ele[metric[1].payload[1].metric_name][metric[1].payload[1].metric_name].value;
                        } else if (metric[1].payload[1].metric_name === "sentiment") {
                            obj.y = parseFloat(advancedNetSentimentMetric(ele[metric[1].payload[1].metric_name].sentiments.group1.group2.buckets).toFixed(2));
                        } else {
                            obj.y = ele[metric[1].payload[1].metric_name][metric[1].payload[1].metric_name].sum;
                        }
                    }
                    totalDataCount += obj.y || 0;
                    let metricsVal = metricsNameObj[metric[1].payload[1].metric_name] || metric[1].payload[1].metric_name;
                    obj.yAxisName = metricsVal;

                    result.rightYAxis.data.push(JSON.parse(JSON.stringify(obj)));
                });
            }
            if (metric[0].payload[1]?.dimension_name !== "published_date") {
                result.leftYAxis.data.sort((a, b) => b.y - a.y);
                result.rightYAxis.data.sort((a, b) => b.y - a.y);
            }
            ret.csvData.data.push(result.leftYAxis);
            ret.csvData.data.push(result.rightYAxis);
            ret.csvData["master_matrix_dimension"] = [];
            ret.csvData.master_matrix_dimension.push(result.leftYAxis.name);
            ret.csvData.master_matrix_dimension.push(result.rightYAxis.name);
        }
        // format 2D 2M
        else {
            if (metric[0].payload[1].dimension_name === "sub_topics_data") {
                let subtopicsRawData = JSON.parse(JSON.stringify(metric[0].payload[0]));
                let subtopicsRawData1 = JSON.parse(JSON.stringify(metric[1].payload[0]));
                let leftData = [];
                let rightData = [];
                subtopicsRawData.forEach((obj) => {
                    obj.subtopics.forEach((subtpcObj) => {
                        leftData.push({
                            ...subtpcObj,
                            topic_id: obj.topic_id,
                            topic_name: obj.topic_name,
                        });
                    });
                });
                subtopicsRawData1.forEach((obj) => {
                    obj.subtopics.forEach((subtpcObj) => {
                        rightData.push({
                            ...subtpcObj,
                            topic_id: obj.topic_id,
                            topic_name: obj.topic_name,
                        });
                    });
                });

                metric[0].payload[0] = leftData.sort((a, b) => b.total - a.total);
                metric[1].payload[0] = rightData;
                // console.log("metricmetric 111", metric[0].payload[0], leftData);
                // console.log("rightDatarightData", rightData);
            }

            let {
                updatedData: leftData,
                validateNoDataCount: count1,
                lineData: leftLineData,
            } = twoDimensionData(
                metric[0].payload[0],
                metric[0].payload[1],
                masterFilterData,
                totalDataCount,
                viewCountCheckbox,
                subtopicObject,
                momentsMeta,
                paramsData,
                tz,
            );
            let {
                updatedData: rightData,
                validateNoDataCount: count2,
                lineData: rightLineData,
            } = twoDimensionData(
                metric[1].payload[0],
                metric[1].payload[1],
                masterFilterData,
                totalDataCount,
                viewCountCheckbox,
                subtopicObject,
                momentsMeta,
                paramsData,
                tz,
            );
            totalDataCount = count1 + count2;
            // console.log("testttt 0 111", count1, count2, totalDataCount);

            leftData.forEach((ele) => {
                ele.stack = "common";
                ele.yAxis = 1;
            });

            rightData.forEach((ele) => {
                ele.linkedTo = ":previous";
            });
            console.log("firstlineDatalineData", leftLineData, rightLineData);

            result.leftYAxis.data = [...result.leftYAxis.data, ...leftData];

            result.rightYAxis.data = [...result.rightYAxis.data, ...rightData];

            result.leftYAxis.lineData = leftLineData;

            result.rightYAxis.lineData = rightLineData;

            console.log("firstlineDatalineDataResult", result);

            ret.csvData.data.push(result.leftYAxis);
            ret.csvData.data.push(result.rightYAxis);
            ret.csvData["master_multi_matrix_dimension"] = [];
            ret.csvData.master_multi_matrix_dimension.push(result.leftYAxis.name);
            ret.csvData.master_multi_matrix_dimension.push(result.rightYAxis.name);

            // console.log(" metric[0].payload[0]", metric[0].payload[0], metric[0].payload[0].slice(0, 9));
            // console.log("result.rightYAxis", result.rightYAxis);
            // const uniqueKeys = new Set();

            // let minLeftData = metric[0].payload[0].slice(0, 9);

            // if (metric[0].payload[1].dimension_name === "topics_data") {
            //     minLeftData = metric[0].payload[0].sort((a, b) => b.total - a.total).slice(0, 9);
            // }

            // minLeftData.forEach((obj) => {
            //     // if (obj.key) uniqueKeys.add(obj.key);
            //     // else if (obj.topic_name) uniqueKeys.add(obj.topic_name);
            //     if (metric[0].payload[1].dimension_name === "topics_data") uniqueKeys.add(obj.topic_id);
            //     else if (metric[0].payload[1].dimension_name === "sub_topics_data") uniqueKeys.add(obj.subtopic_id);
            //     else if (obj.key) uniqueKeys.add(obj.key);
            // });

            // let minRightData = [];
            // let othersRawRightData = [];

            // metric[1].payload[0].forEach((rightDataObj) => {
            //     if (metric[0].payload[1].dimension_name === "topics_data") {
            //         if (uniqueKeys.has(rightDataObj.topic_id)) {
            //             minRightData.push(rightDataObj);
            //         } else othersRawRightData.push(rightDataObj);
            //     } else if (metric[0].payload[1].dimension_name === "sub_topics_data") {
            //         if (uniqueKeys.has(rightDataObj.subtopic_id)) {
            //             minRightData.push(rightDataObj);
            //         } else othersRawRightData.push(rightDataObj);
            //     } else {
            //         if (uniqueKeys.has(rightDataObj.key)) minRightData.push(rightDataObj);
            //         else othersRawRightData.push(rightDataObj);
            //     }

            //     // if (uniqueKeys.has(rightDataObj.key || rightDataObj.topic_name)) {
            //     //     minRightData.push(rightDataObj);
            //     // } else othersRawRightData.push(rightDataObj);
            // });

            // let { updatedData: leftMinimizedData } = twoDimensionData(
            //     minLeftData,
            //     metric[0].payload[1],
            //     masterFilterData,
            //     totalDataCount,
            //     viewCountCheckbox,
            //     subtopicObject,
            // );
            // let { updatedData: rightMinimizedData } = twoDimensionData(
            //     minRightData,
            //     metric[1].payload[1],
            //     masterFilterData,
            //     totalDataCount,
            //     viewCountCheckbox,
            //     subtopicObject,
            // );

            // let { updatedData: othersLeftData } = twoDimensionData(
            //     metric[0].payload[0].slice(9),
            //     metric[0].payload[1],
            //     masterFilterData,
            //     totalDataCount,
            //     viewCountCheckbox,
            //     subtopicObject,
            // );
            // let { updatedData: othersRightData } = twoDimensionData(
            //     othersRawRightData,
            //     metric[1].payload[1],
            //     masterFilterData,
            //     totalDataCount,
            //     viewCountCheckbox,
            //     subtopicObject,
            // );
            // const addOthersVal = (data, ohersArr, type) => {
            //     let formattedData = [...data];
            //     formattedData.forEach((dataObj) => {
            //         let d = ohersArr.find((obj) => obj.name === dataObj.name);

            //         if (d) {
            //             let yValue = 0;
            //             let dataIds = [];
            //             let breakDownIds = [];
            //             let breakdownDimensionName, dimensionName, yAxisName;

            //             d.data?.forEach((obj) => {
            //                 yValue += obj.y;
            //                 dataIds.push(obj.dataId);
            //                 breakDownIds.push(obj.breakDownId);
            //                 breakdownDimensionName = obj.breakdownDimensionName;
            //                 dimensionName = obj.dimensionName;
            //                 yAxisName = obj.yAxisName;
            //             });
            //             let othersFormattedData = {
            //                 name: "Others",
            //                 y: yValue || 0,
            //                 dataId: dataIds,
            //                 breakdownDimensionName,
            //                 dimensionName,
            //                 yAxisName,
            //                 breakDownId: breakDownIds,
            //             };

            //             dataObj.data?.push(othersFormattedData);
            //         }
            //         if (type === "right") dataObj.linkedTo = ":previous";
            //         else {
            //             dataObj.stack = "common";
            //             dataObj.yAxis = 1;
            //         }
            //     });
            //     return formattedData;
            // };

            // const left = addOthersVal(leftMinimizedData, othersLeftData, "left");
            // const right = addOthersVal(rightMinimizedData, othersRightData, "right");

            // // result.minimized.leftYAxis = [...left];
            // // result.minimized.rightYAxis = [...right];

            // let min = {
            //     leftYAxis: { ...result.leftYAxis, data: [...left] },
            //     rightYAxis: { ...result.rightYAxis, data: [...right] },
            // };
            // // result.leftYAxis.data= [...left]
            // // console.log("test12343212345", min, result);
            // result.minimizedData = min;
        }
    } catch (error) {
        console.log("error occured", error);
    }

    ret.data = result;
    if ((result?.rightYAxis?.data?.length === 0 && result?.leftYAxis?.data?.length === 0) || totalDataCount === 0) {
        ret.nodata = true;
        ret.data.nodata = true;
    }
    if (metric[0].payload[1].breakdown_dimension_name !== "") {
        //     ret.maximizeData = JSON.parse(JSON.stringify(ret.data));
        //     let leftAxisData = JSON.parse(JSON.stringify(ret.data.leftYAxis));
        //     let rightAxisData = JSON.parse(JSON.stringify(ret.data.rightYAxis));

        //     const formatNinePlusOneData = (reqObj) => {
        //         let formattedData = reqObj.data?.map((leftDataObj) => {
        //             // console.log("leftData 1111", leftDataObj.data?.length, leftDataObj);

        //             if (leftDataObj.data?.length > 9) {
        //                 let data = leftDataObj.data.slice(0, 9);
        //                 let othersData = leftDataObj.data.slice(9);
        //                 let yValue = 0;
        //                 let dataIds = [];
        //                 let breakdownDimensionName, dimensionName, yAxisName;

        //                 othersData.forEach((othersObj) => {
        //                     breakdownDimensionName = othersObj.breakdownDimensionName;
        //                     dimensionName = othersObj.dimensionName;
        //                     yAxisName = othersObj.yAxisName;
        //                     yValue += othersObj.y;
        //                     dataIds.push(othersObj.dataId);
        //                 });
        //                 let others = { name: "Others", y: yValue || 0, dataId: dataIds, breakdownDimensionName, dimensionName, yAxisName };

        //                 data.push(others);
        //                 // console.log("leftData 222", data);

        //                 return { ...leftDataObj, data };
        //             }
        //             // console.log("leftData 3333", leftDataObj);

        //             return leftDataObj;
        //         });
        //         return formattedData;
        //     };
        //     let leftData = formatNinePlusOneData(leftAxisData);
        //     let rightData = formatNinePlusOneData(rightAxisData);

        //     console.log("leftData", ret, rightData);
        //     ret.data.leftYAxis.data = JSON.parse(JSON.stringify(leftData));
        //     ret.data.rightYAxis.data = JSON.parse(JSON.stringify(rightData));
        // ret.minimizedData = {
        //     ...ret.leftYAxis,
        //     ...ret.rightYAxis,
        // };
        // console.log("retret", ret);
        // ret.minimizedData.leftYAxis.data == JSON.parse(JSON.stringify(ret.minimized.leftYAxis));
        // ret.minimizedData.rightYAxis.data == JSON.parse(JSON.stringify(ret.minimized.rightYAxis));
        // console.log("retret", ret);
        console.log("firstrettt", ret);
        return ret;
    }

    // console.log("testttt 111", totalDataCount);
    // if (metric[0].payload[1].breakdown_dimension_name == "") {
    ret.maximizeData = JSON.parse(JSON.stringify(ret.data));
    // console.log("firstrettt", ret.data);
    let initialLeftData = ret.data.leftYAxis.data.slice(0, 9);
    let OthersLeftData = ret.data.leftYAxis.data.slice(9);
    // let initialRightData = ret.data.rightYAxis.data.slice(0, 9);
    // let OthersRightData = ret.data.rightYAxis.data.slice(9);

    // console.log("testting hereee", JSON.parse(JSON.stringify(initialLeftData)), JSON.parse(JSON.stringify(initialRightData)));
    // let rightDataNotPresentInLeftObj = [];

    // initialLeftData.forEach((leftDataObj) => {
    //     let isDataPresent = initialRightData.filter((rightDataObj) => rightDataObj?.name === leftDataObj?.name);
    //     console.log("isDataPresent", isDataPresent?.length, leftDataObj?.name);
    //     if (isDataPresent.length === 0) {
    //         let newRightObj = { ...leftDataObj, y: 0 };
    //         console.log("isDataPresent", leftDataObj, newRightObj);

    //         initialRightData?.push(newRightObj);

    //         console.log("initialRightData", initialRightData);
    //         initialRightData.forEach((rightData) => {
    //             let uniqueData = initialLeftData.filter((leftData) => leftData?.name === rightData.name);
    //             // console.log("uniqueData 11", uniqueData);
    //             if (uniqueData.length === 0) {
    //                 console.log("uniqueData 22", rightData);
    //                 rightDataNotPresentInLeftObj.push(rightData);
    //                 initialRightData = initialRightData.filter((rightObj) => rightObj.name !== rightData.name);
    //             }
    //         });
    //     }
    // });

    let initialRightData = [];
    let uniqueRightDataKey = new Set();
    initialLeftData.forEach((leftDataObj) => {
        let isDataPresent = ret.data.rightYAxis.data.filter((rightDataObj) => rightDataObj?.name === leftDataObj?.name);
        // console.log("isDataPresentisDataPresent", isDataPresent?.[0], leftDataObj);
        if (isDataPresent?.length === 1) {
            initialRightData.push(...isDataPresent);
            uniqueRightDataKey.add(isDataPresent?.[0]?.name);
        } else {
            //no data found.. create new with y:0
            initialRightData.push({ ...leftDataObj, y: 0 });
        }
    });

    let OthersRightData = [];
    ret.data.rightYAxis.data?.forEach((rightDataObj) => {
        if (!uniqueRightDataKey.has(rightDataObj.name)) {
            // console.log("testtttt 2222", rightDataObj);
            OthersRightData.push({ ...rightDataObj });
        }
    });

    let yValueLeftData = 0;
    let leftDataIds = [];
    let leftMetricName, leftDimensionName, leftYAxisName;
    // console.log("OtherLeftData", OthersLeftData);
    OthersLeftData.forEach((o) => {
        yValueLeftData += o.y || 0;
        leftDataIds.push(o.dataId);
        leftYAxisName = o.data?.[0]?.yAxisName || "";
        leftDimensionName = o.dimensionName || "";
        leftMetricName = o.metricName || "";
    });
    if (metric[0].payload[1].metric_name === "sentiment") yValueLeftData = +yValueLeftData.toFixed(2);

    // console.log("OtherLeftData", leftDataIds);
    if (ret.data.leftYAxis.data.length > 9) {
        let othersLeftData = {
            name: "Others",
            y: yValueLeftData,
            dataId: leftDataIds,
            metricName: leftMetricName,
            dimensionName: leftDimensionName,
            yAxisName: leftYAxisName,
        };
        initialLeftData.push({
            data: [othersLeftData],
            dataId: leftDataIds,
            name: "Others",
            // color: intToRGB(hashCode("Others")),
            y: yValueLeftData,
            dimensionName: othersLeftData.dimensionName,
            metricName: othersLeftData.metricName,
            // othersItems: others,
        });
    }

    let yValueRightData = 0;
    let rightDataIds = [];
    let metricName, dimensionName, yAxisName;
    OthersRightData.forEach((o) => {
        yValueRightData += o.y;
        rightDataIds.push(o.dataId);
        yAxisName = o.data?.[0]?.yAxisName || "";
        dimensionName = o.dimensionName || "";
        metricName = o.metricName || "";
    });
    // console.log("OthersRightData 11", rightDataNotPresentInLeftObj, JSON.parse(JSON.stringify(rightDataIds)), JSON.parse(JSON.stringify(yValueRightData)));
    // if (rightDataNotPresentInLeftObj?.length > 0) {
    //     rightDataNotPresentInLeftObj.forEach((rightArr) => {
    //         console.log("rightArrrightArr", rightArr.y);
    //         yValueRightData += +rightArr.y || 0;
    //         rightDataIds.push(rightArr.dataId);
    //     });
    // }
    // console.log("OthersRightData 22222", rightDataIds, yValueRightData);
    if (metric[1].payload[1].metric_name === "sentiment") yValueRightData = +yValueRightData.toFixed(2);

    if (ret.data.leftYAxis.data.length > 9) {
        let othersRightData = { name: "Others", y: yValueRightData || 0, dataId: rightDataIds, metricName, dimensionName, yAxisName };

        initialRightData.push({
            data: [othersRightData],
            dataId: rightDataIds,
            name: "Others",
            // color: intToRGB(hashCode("Others")),
            y: yValueRightData || 0,
            dimensionName: othersRightData.dimensionName,
            metricName: othersRightData.metricName,
            // othersItems: others,
        });
    }
    ret.data.leftYAxis.data = JSON.parse(JSON.stringify(initialLeftData));
    ret.data.rightYAxis.data = JSON.parse(JSON.stringify(initialRightData));

    ret.data.leftYAxis.data.sort((a, b) => b.value - a.value);
    ret.data.rightYAxis.data.sort((a, b) => b.value - a.value);
    ret.maximizeData.leftYAxis.data.sort((a, b) => b.value - a.value);
    ret.maximizeData.rightYAxis.data.sort((a, b) => b.value - a.value);
    // }
    //    = [...initialLeftData,...initialRightData];
    console.log("firstrettt", ret);
    return ret;
};

const format2D2MTopicsSubTopicsData = (metric, listData, masterFilterData, totalDataCount, viewCountCheckbox, subtopicObject, momentsMeta) => {
    let unsorted_dimension2 = [];
    let dimension2_data = [];
    let master_dimension2 = [];
    let key_dimension2 = [];
    let unique_dimension2 = [];
    let idData;
    if (listData.breakdown_dimension_name === "platforms") {
        idData = masterFilterData.masterPlatforms;
    } else if (listData.breakdown_dimension_name === "countries") {
        idData = masterFilterData.masterLocations;
    } else if (listData.breakdown_dimension_name === "languages") {
        idData = masterFilterData.masterLanguages;
    }

    metric.forEach((ele, g) => {
        dimension2_data[g] =
            listData.breakdown_dimension_name === "sentiments"
                ? ele.aggregations.sentiments.group1.group2.buckets
                : ele.aggregations[listData.breakdown_dimension_name].buckets;
    });

    master_dimension2 = dimension2_data.flatMap((array) => array);

    master_dimension2.forEach((item, i) => {
        if (item.user_latest_post?.hits?.hits[0]?._source?.post_author) {
            key_dimension2[i] = {
                key: item.key,
                post_author: item.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                    ? item.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                    : item.key,
            };
        } else {
            key_dimension2[i] = item.key;
        }
    });

    if (typeof key_dimension2[0] === "object") {
        unique_dimension2 = key_dimension2.filter((item, index, array) => {
            return array.findIndex((obj) => obj.key === item.key) === index;
        });
    } else {
        unique_dimension2 = [...new Set(key_dimension2)];
    }

    if (listData.dimension_name === "topics_data") {
        metric.forEach((dim1) => {
            let arrayObject = dim1.aggregations?.[listData.breakdown_dimension_name]?.group1?.group2
                ? dim1.aggregations?.[listData.breakdown_dimension_name]?.group1.group2.buckets
                : dim1.aggregations?.[listData.breakdown_dimension_name]?.buckets;

            unique_dimension2.forEach((ele) => {
                let temporaryBreakdown;
                let mainPlatformValue;
                mainPlatformValue = dim1.topic_name;
                let influencerId;
                switch (listData.breakdown_dimension_name) {
                    case "published_date":
                        // main_breakdown_dimension = subDim.key_as_string;
                        temporaryBreakdown = moment(ele).format("YYYY-MM-DD");

                        break;
                    case "post_types":
                        temporaryBreakdown = post_types_names[ele];

                        break;

                    case "entity_sub_type":
                        temporaryBreakdown = toTitleCase(ele);

                        break;

                    case "entity_types":
                        temporaryBreakdown = toTitleCase(ele);

                        break;

                    case "moments":
                        temporaryBreakdown = momentsMeta.find((elem) => elem.id === ele)?.name || ele;

                        break;

                    case "product_attributes": {
                        let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === ele);
                        temporaryBreakdown = ProductAttributesName[0]?.attributeName || ele;
                        break;
                    }
                    case "sentiments": {
                        temporaryBreakdown = toTitleCase(ele);
                        break;
                    }
                    case "top_influencers":
                        temporaryBreakdown = ele.post_author;
                        influencerId = ele.key;

                        break;

                    default:
                        temporaryBreakdown = ele;
                }

                unsorted_dimension2.push({
                    main_platform: mainPlatformValue,
                    dimension_id: dim1.topic_id,
                    breakdown_dimension_id: influencerId ? influencerId : ele,
                    main_breakdown_dimension: temporaryBreakdown,
                    breakdown_count: 0,
                });
            });

            arrayObject.forEach((subDim) => {
                let main_platform, dimensionId, breakdownId;
                let main_breakdown_dimension;
                main_platform = dim1.topic_name;
                dimensionId = dim1.topic_id;
                let publishBreakId;
                // main_breakdown_dimension = subDim.key;
                let breakdown_count;
                switch (listData.breakdown_dimension_name) {
                    case "published_date":
                        // main_breakdown_dimension = subDim.key_as_string;
                        main_breakdown_dimension = moment(subDim.key_as_string).format("YYYY-MM-DD");
                        breakdownId = subDim.key;
                        publishBreakId = subDim.key_as_string;

                        break;
                    case "post_types":
                        main_breakdown_dimension = post_types_names[subDim.key];
                        breakdownId = subDim.key;
                        break;

                    case "product_attributes": {
                        let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === subDim.key);
                        main_breakdown_dimension = ProductAttributesName[0]?.attributeName || subDim.key;
                        breakdownId = ProductAttributesName[0]?.attributeName || subDim.key;
                        breakdownId = subDim.key;
                        break;
                    }

                    case "sentiments":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownId = subDim.key;
                        break;
                    case "entity_sub_type":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownId = subDim.key;
                        break;

                    case "entity_types":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownId = subDim.key;
                        break;
                    case "moments":
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        main_breakdown_dimension = momentsMeta.find((elem) => elem.id === breakdownId)?.name || breakdownId;
                        break;

                    case "top_influencers":
                        main_breakdown_dimension = subDim.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            ? subDim.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            : subDim.key;
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        break;

                    default:
                        main_breakdown_dimension = subDim.key;
                        breakdownId = subDim.key;
                }

                if (listData.breakdown_dimension_name !== "sentiments") {
                    if (listData.metric_name === "mention") {
                        breakdown_count = subDim.doc_count;
                    } else if (listData.metric_name === "enagagment_value") {
                        if (viewCountCheckbox) {
                            // console.log("zoro",viewCountCheckbox,subDim.view_count.sum);
                            breakdown_count = subDim.comment_count.sum + subDim.like_count.sum + subDim.share_count.sum;
                        } else {
                            // console.log("zoro",viewCountCheckbox,subDim.view_count.sum);
                            breakdown_count = subDim.view_count.sum + subDim.comment_count.sum + subDim.like_count.sum + subDim.share_count.sum;
                        }
                    } else if (listData.metric_name === "unique_user") {
                        breakdown_count = subDim[listData.metric_name].value;
                    } else if (listData.metric_name === "sentiment") {
                        breakdown_count = parseFloat(advancedNetSentimentMetric(subDim.sentiments.group1.group2.buckets).toFixed(2));
                    } else {
                        breakdown_count = subDim[listData.metric_name]?.sum;
                    }
                } else {
                    if (listData.metric_name === "mention") {
                        breakdown_count = subDim.doc_count;
                    } else if (listData.metric_name === "enagagment_value") {
                        if (viewCountCheckbox) {
                            // console.log("zoro",viewCountCheckbox,subDim[listData.metric_name].view_count.sum);
                            breakdown_count =
                                subDim[listData.metric_name].comment_count.sum +
                                subDim[listData.metric_name].like_count.sum +
                                subDim[listData.metric_name].share_count.sum;
                        } else {
                            // console.log("zoro",viewCountCheckbox,subDim[listData.metric_name].view_count.sum);
                            breakdown_count =
                                subDim[listData.metric_name].view_count.sum +
                                subDim[listData.metric_name].comment_count.sum +
                                subDim[listData.metric_name].like_count.sum +
                                subDim[listData.metric_name].share_count.sum;
                        }
                    } else if (listData.metric_name === "unique_user") {
                        breakdown_count = subDim[listData.metric_name][listData.metric_name]?.value;
                    } else if (listData.metric_name === "sentiment") {
                        breakdown_count = parseFloat(advancedNetSentimentMetric(subDim.sentiment.sentiments.group1.group2.buckets).toFixed(2));
                    } else {
                        breakdown_count = subDim[listData.metric_name][listData.metric_name]?.sum;
                    }
                }

                unsorted_dimension2.forEach((ele) => {
                    if (ele.breakdown_dimension_id == breakdownId && ele.dimension_id == dimensionId) {
                        ele.breakdown_count = breakdown_count;
                        ele.main_platform = main_platform;
                        ele.main_breakdown_dimension = main_breakdown_dimension;
                    }
                });
            });
        });
    } else {
        metric.forEach((subTopicsArr) => {
            let arrayObject = subTopicsArr?.aggregations?.[listData.breakdown_dimension_name]?.group1?.group2
                ? subTopicsArr?.aggregations?.[listData.breakdown_dimension_name]?.group1?.group2?.buckets
                : subTopicsArr?.aggregations?.[listData.breakdown_dimension_name]?.buckets;

            unique_dimension2.forEach((ele) => {
                let temporaryBreakdown;
                let mainPlatformValue;
                let influencerId;
                mainPlatformValue = subTopicsArr.subtopic_name + "(" + `${subtopicObject[subTopicsArr.subtopic_id].subtopic_topic_name}` + ")";

                switch (listData.breakdown_dimension_name) {
                    case "published_date":
                        // main_breakdown_dimension = subDim.key_as_string;
                        temporaryBreakdown = moment(ele).format("YYYY-MM-DD");

                        break;
                    case "post_types":
                        temporaryBreakdown = post_types_names[ele];

                        break;

                    case "entity_sub_type":
                        temporaryBreakdown = toTitleCase(ele);

                        break;

                    case "entity_types":
                        temporaryBreakdown = toTitleCase(ele);

                        break;

                    case "moments":
                        temporaryBreakdown = momentsMeta.find((elem) => elem.id === ele)?.name || ele;

                        break;

                    case "product_attributes": {
                        let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === ele);
                        temporaryBreakdown = ProductAttributesName[0]?.attributeName || ele;
                        break;
                    }
                    case "sentiments": {
                        temporaryBreakdown = toTitleCase(ele);
                        break;
                    }

                    case "top_influencers":
                        temporaryBreakdown = ele.post_author;
                        influencerId = ele.key;

                        break;

                    default:
                        temporaryBreakdown = ele;
                }

                unsorted_dimension2.push({
                    main_platform: mainPlatformValue,
                    dimension_id: subTopicsArr.subtopic_id,
                    breakdown_dimension_id: influencerId ? influencerId : ele,
                    main_breakdown_dimension: temporaryBreakdown,
                    breakdown_count: 0,
                });
            });

            // dim1?.subtopics?.forEach((subTopicsArr) => {
            arrayObject.forEach((subDim) => {
                let main_platform, dimensionId, breakdownId;
                let main_breakdown_dimension;
                main_platform = subTopicsArr.subtopic_name + "(" + `${subtopicObject[subTopicsArr.subtopic_id].subtopic_topic_name}` + ")";
                dimensionId = subTopicsArr.subtopic_id;
                let publishBreakId;
                switch (listData.breakdown_dimension_name) {
                    case "published_date":
                        // main_breakdown_dimension = subDim.key_as_string;
                        main_breakdown_dimension = moment(subDim.key_as_string).format("YYYY-MM-DD");
                        breakdownId = subDim.key;
                        publishBreakId = subDim.key_as_string;
                        break;
                    case "post_types":
                        main_breakdown_dimension = post_types_names[subDim.key];
                        breakdownId = subDim.key;
                        break;

                    case "product_attributes": {
                        let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === subDim.key);
                        main_breakdown_dimension = ProductAttributesName[0]?.attributeName || subDim.key;
                        breakdownId = ProductAttributesName[0]?.attributeName || subDim.key;
                        breakdownId = subDim.key;
                        break;
                    }
                    case "entity_sub_type":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownId = subDim.key;
                        break;

                    case "sentiments":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownId = subDim.key;
                        break;
                    case "entity_types":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownId = subDim.key;
                        break;

                    case "moments":
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        main_breakdown_dimension = momentsMeta.find((elem) => elem.id === breakdownId)?.name || breakdownId;
                        break;

                    case "top_influencers":
                        main_breakdown_dimension = subDim.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            ? subDim.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            : subDim.key;
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        break;
                    default:
                        main_breakdown_dimension = subDim.key;
                        breakdownId = subDim.key;
                }

                let breakdown_count;
                if (listData.breakdown_dimension_name !== "sentiments") {
                    if (listData.metric_name === "mention") {
                        breakdown_count = subDim.doc_count;
                    } else if (listData.metric_name === "enagagment_value") {
                        if (viewCountCheckbox) {
                            // console.log("zoro",viewCountCheckbox,subDim.view_count.sum);
                            breakdown_count = subDim.comment_count.sum + subDim.like_count.sum + subDim.share_count.sum;
                        } else {
                            // console.log("zoro",viewCountCheckbox,subDim.view_count.sum);
                            breakdown_count = subDim.view_count.sum + subDim.comment_count.sum + subDim.like_count.sum + subDim.share_count.sum;
                        }
                    } else if (listData.metric_name === "unique_user") {
                        breakdown_count = subDim[listData.metric_name]?.value;
                    } else if (listData.metric_name === "sentiment") {
                        breakdown_count = parseFloat(advancedNetSentimentMetric(subDim.sentiments.group1.group2.buckets).toFixed(2));
                    } else {
                        breakdown_count = subDim[listData.metric_name]?.sum;
                    }
                } else {
                    if (listData.metric_name === "mention") {
                        breakdown_count = subDim.doc_count;
                    } else if (listData.metric_name === "enagagment_value") {
                        if (viewCountCheckbox) {
                            // console.log("zoro",viewCountCheckbox,subDim[listData.metric_name].view_count.sum);
                            breakdown_count =
                                subDim[listData.metric_name].comment_count.sum +
                                subDim[listData.metric_name].like_count.sum +
                                subDim[listData.metric_name].share_count.sum;
                        } else {
                            // console.log("zoro",viewCountCheckbox,subDim[listData.metric_name].view_count.sum);
                            breakdown_count =
                                subDim[listData.metric_name].view_count.sum +
                                subDim[listData.metric_name].comment_count.sum +
                                subDim[listData.metric_name].like_count.sum +
                                subDim[listData.metric_name].share_count.sum;
                        }
                    } else if (listData.metric_name === "unique_user") {
                        breakdown_count = subDim[listData.metric_name][listData.metric_name]?.value;
                    } else if (listData.metric_name === "sentiment") {
                        breakdown_count = parseFloat(advancedNetSentimentMetric(subDim.sentiment.sentiments.group1.group2.buckets).toFixed(2));
                    } else {
                        breakdown_count = subDim[listData.metric_name][listData.metric_name]?.sum;
                    }
                }

                unsorted_dimension2.forEach((ele) => {
                    if (ele.breakdown_dimension_id == breakdownId && ele.dimension_id == dimensionId) {
                        ele.breakdown_dimension_id = publishBreakId ? publishBreakId : breakdownId;
                        ele.breakdown_count = breakdown_count;
                        ele.main_platform = main_platform;
                        ele.main_breakdown_dimension = main_breakdown_dimension;
                    }
                });
            });
            // });
        });
    }
    const transformed_dimension2 = [];
    unsorted_dimension2.sort((a, b) => b.breakdown_count - a.breakdown_count);
    let color;
    const allowedValues = ["Person", "Non-person", "Male", "Female", "Brand", "News", "person", "non-person", "male", "female", "brand", "news"]; //Unknown
    // console.log("unsorted_dimension2 2134323", JSON.parse(JSON.stringify(unsorted_dimension2)));
    if (listData.breakdown_dimension_name === "entity_sub_type" || listData.breakdown_dimension_name === "entity_types")
        unsorted_dimension2 = unsorted_dimension2.filter((obj) => {
            // return allowedValues.includes(obj.main_breakdown_dimension)}
            if (allowedValues.includes(obj.main_breakdown_dimension)) return true;
            return false;
        });
    unsorted_dimension2.forEach((topic) => {
        const existingTopic = transformed_dimension2.find((item) => item.main_breakdown_dimension === topic.main_breakdown_dimension);
        switch (listData.breakdown_dimension_name) {
            case "sentiments":
                color = getSentimentColor(topic.main_breakdown_dimension.toLowerCase());
                break;

            case "platforms":
                color = getPlatformColorCode(topic.main_breakdown_dimension);
                break;

            case "entity_sub_type":
                color = getEntityColor(topic.main_breakdown_dimension.toLowerCase());
                break;

            case "entity_types":
                color = getEntityColor(topic.main_breakdown_dimension.toLowerCase());
                break;

            case "published_date":
                color = intToRGB(hashCode(moment(topic.breakdown_dimension_id).format()));
                break;

            default:
                color = intToRGB(hashCode(topic.main_breakdown_dimension));
        }
        // let formattedDimensionName= dimensionNameObj[listData.dimension_name]|| listData.dimension_name
        let formattedBreakdownDimensionName = dimensionNameObj[listData.breakdown_dimension_name] || listData.breakdown_dimension_name;
        let formattedMetricsName = metricsNameObj[listData?.metric_name] || listData?.metric_name;
        let id1;
        if (idData) {
            let reqObject = idData.find((obj) => obj.name === topic.main_breakdown_dimension);
            id1 = reqObject?.id;
        } else if (listData.breakdown_dimension_name === "post_types") {
            id1 = topic.be;
        } else {
            id1 = topic.breakdown_dimension_id;
        }

        if (existingTopic) {
            existingTopic.data.push({
                name: topic.main_platform,
                y: topic.breakdown_count,
                dataId: topic.dimension_id,
                color: color,
                yAxisName: formattedMetricsName, //listData.breakdown_dimension_name
                dimensionName: listData.dimension_name,
                breakdownDimensionName: formattedBreakdownDimensionName,
                breakDownId: id1 ? id1 : topic.breakdown_dimension_id,
                breakDownName: topic.main_breakdown_dimension,
            });
            totalDataCount += topic.breakdown_count;
        } else {
            transformed_dimension2.push({
                main_breakdown_dimension: topic.main_breakdown_dimension,
                color: color,
                dataId: id1 ? id1 : topic.breakdown_dimension_id,
                data: [
                    {
                        name: topic.main_platform,
                        y: topic.breakdown_count,
                        dataId: topic.dimension_id,
                        color: color,
                        yAxisName: formattedMetricsName, //listData.breakdown_dimension_name
                        dimensionName: listData.dimension_name,
                        breakdownDimensionName: formattedBreakdownDimensionName,
                        breakDownId: id1 ? id1 : topic.breakdown_dimension_id,
                        breakDownName: topic.main_breakdown_dimension, //listData.breakdown_dimension_name,
                    },
                ],
            });
            totalDataCount += topic.breakdown_count;
        }
    });
    transformed_dimension2.forEach((ele) => {
        ele.name = ele.main_breakdown_dimension;
        delete ele.main_breakdown_dimension;
    });

    if (listData.breakdown_dimension_name == "published_date") {
        transformed_dimension2.sort((a, b) => {
            if (a.dataId > b.dataId) return 1;
            if (a.dataId < b.dataId) return -1;
        });
    }
    let updatedData = [];
    updatedData = transformed_dimension2.filter((item) => item.name !== "");
    // updatedData = [...updatedData, transformed_dimension2];
    // ret.data.push(...transformed_dimension2);
    // ret.csvData.data.push(...transformed_dimension2);

    // console.log("AdvanceRetIn2d1mTopic", ret);
    let validateNoDataCount = totalDataCount;
    return { updatedData, validateNoDataCount };
};

const twoDimensionData = (metric, listData, masterFilterData, totalDataCount = 0, viewCountCheckbox, subtopicObject, momentsMeta, paramsData, tz) => {
    console.log("firstmetric", metric, listData);
    if (["topics_data", "sub_topics_data"].includes(listData.dimension_name)) {
        let ret = format2D2MTopicsSubTopicsData(metric, listData, masterFilterData, totalDataCount, viewCountCheckbox, subtopicObject, momentsMeta);
        // console.log("2d2m ret", ret);
        return { updatedData: ret.updatedData, validateNoDataCount: ret.validateNoDataCount };
    }
    let dimension1 = metric;
    let unsorted_dimension2 = [];
    let dimension2_data = [];
    let master_dimension2 = [];
    let key_dimension2 = [];
    let unique_dimension2 = [];

    let idData, idData_dimension;
    if (listData.breakdown_dimension_name === "platforms") {
        idData = masterFilterData.masterPlatforms;
    } else if (listData.breakdown_dimension_name === "countries") {
        idData = masterFilterData.masterLocations;
    } else if (listData.breakdown_dimension_name === "languages") {
        idData = masterFilterData.masterLanguages;
    }

    if (listData.dimension_name === "platforms") {
        idData_dimension = masterFilterData.masterPlatforms;
    } else if (listData.dimension_name === "countries") {
        idData_dimension = masterFilterData.masterLocations;
    } else if (listData.dimension_name === "languages") {
        idData_dimension = masterFilterData.masterLanguages;
    }

    dimension1.forEach((ele, g) => {
        dimension2_data[g] =
            listData.breakdown_dimension_name == "sentiments"
                ? ele[listData.breakdown_dimension_name].group1.group2.buckets
                : listData.dimension_name === "sentiments"
                ? ele[listData.breakdown_dimension_name][listData.breakdown_dimension_name].buckets
                : ele[listData.breakdown_dimension_name].buckets;
    });

    master_dimension2 = dimension2_data.flatMap((array) => array);
    master_dimension2.forEach((item, i) => {
        if (item.user_latest_post?.hits?.hits[0]?._source?.post_author) {
            key_dimension2[i] = {
                key: item.key,
                post_author: item.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                    ? item.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                    : item.key,
            };
        } else {
            key_dimension2[i] = item.key;
        }
    });

    if (typeof key_dimension2[0] === "object") {
        unique_dimension2 = key_dimension2.filter((item, index, array) => {
            return array.findIndex((obj) => obj.key === item.key) === index;
        });
    } else {
        unique_dimension2 = [...new Set(key_dimension2)];
    }

    // console.log("xyz", unique_dimension2);

    let dimensionId, breakdownDimensionId;
    if (listData.dimension_name == "entity_sub_type" || listData.dimension_name == "entity_types")
        dimension1 = dimension1?.filter((obj) => ["person", "non-person", "male", "female", "brand", "news"].indexOf(obj.key) !== -1);
    dimension1.forEach((dim1, dim1_ind) => {
        unique_dimension2.forEach((ele) => {
            let temporaryBreakdown;
            let mainPlatformValue;
            let influencerId;

            switch (listData.dimension_name) {
                case "published_date":
                    // main_platform = dim1.key_as_string;
                    mainPlatformValue = moment(dim1.key_as_string).format("YYYY-MM-DD");

                    break;
                case "post_types":
                    mainPlatformValue = post_types_names[dim1.key];

                    break;

                case "entity_sub_type":
                    mainPlatformValue = dim1.key.charAt(0).toUpperCase() + dim1.key.substr(1).toLowerCase();

                    break;

                case "entity_types":
                    mainPlatformValue = dim1.key.charAt(0).toUpperCase() + dim1.key.substr(1).toLowerCase();

                    break;

                case "product_attributes": {
                    let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === dim1.key);
                    mainPlatformValue = ProductAttributesName[0]?.attributeName || dim1.key;

                    break;
                }

                case "moments":
                    mainPlatformValue = momentsMeta.find((elem) => elem.id === dim1.key)?.name;
                    break;

                case "top_influencers":
                    mainPlatformValue = dim1.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                        ? dim1.user_latest_post.hits.hits[0]?._source?.post_author?.name
                        : dim1.key;
                    break;
                default:
                    mainPlatformValue = toTitleCase(dim1.key);
            }
            switch (listData.breakdown_dimension_name) {
                case "published_date":
                    // main_breakdown_dimension = subDim.key_as_string;
                    temporaryBreakdown = moment(ele).format("YYYY-MM-DD");

                    break;
                case "post_types":
                    temporaryBreakdown = post_types_names[ele];

                    break;

                case "entity_sub_type":
                    temporaryBreakdown = toTitleCase(ele);

                    break;

                case "entity_types":
                    temporaryBreakdown = toTitleCase(ele);

                    break;

                case "moments":
                    temporaryBreakdown = momentsMeta.find((elem) => elem.id === ele)?.name || ele;

                    break;

                case "product_attributes": {
                    let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === ele);
                    temporaryBreakdown = ProductAttributesName[0]?.attributeName || ele;
                    break;
                }
                case "sentiments": {
                    temporaryBreakdown = toTitleCase(ele);
                    break;
                }
                case "top_influencers":
                    temporaryBreakdown = ele.post_author;
                    influencerId = ele.key;

                    break;

                default:
                    temporaryBreakdown = ele;
            }

            unsorted_dimension2.push({
                name: mainPlatformValue,
                dimension_id: dim1.key,
                breakdown_dimension_id: influencerId ? influencerId : ele,
                main_breakdown_dimension: temporaryBreakdown,
                y: 0,
            });
        });

        if (listData.breakdown_dimension_name === "sentiments") {
            dim1[listData.breakdown_dimension_name].group1.group2.buckets.forEach((subDim, subDim_ind) => {
                let main_dimension;
                let mainBreakdown_dimension;

                switch (listData.dimension_name) {
                    case "published_date":
                        // main_dimension = dim1.key_as_string;
                        main_dimension = moment(dim1.key_as_string).format("YYYY-MM-DD");
                        dimensionId = dim1.key;
                        break;
                    case "post_types":
                        main_dimension = post_types_names[dim1.key];
                        dimensionId = dim1.key;
                        break;

                    case "entity_sub_type":
                        main_dimension = toTitleCase(dim1.key);
                        dimensionId = dim1.key;
                        break;

                    case "entity_types":
                        main_dimension = toTitleCase(dim1.key);
                        dimensionId = dim1.key;
                        break;

                    case "product_attributes": {
                        let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === dim1.key);
                        main_dimension = ProductAttributesName[0]?.attributeName || dim1.key;
                        dimensionId = dim1.key;
                        break;
                    }

                    case "moments":
                        dimensionId = JSON.parse(JSON.stringify(dim1.key));
                        main_dimension = momentsMeta.find((elem) => elem.id === dimensionId)?.name || dimensionId;
                        break;

                    case "top_influencers":
                        main_dimension = dim1.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            ? dim1.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            : dim1.key;
                        dimensionId = JSON.parse(JSON.stringify(dim1.key));
                        break;

                    default:
                        main_dimension = toTitleCase(dim1.key);
                        dimensionId = dim1.key;
                }

                mainBreakdown_dimension = toTitleCase(subDim.key);
                breakdownDimensionId = subDim.key;

                let breakdown_count;
                if (listData.metric_name === "mention") {
                    breakdown_count = subDim.doc_count;
                } else if (listData.metric_name === "enagagment_value") {
                    if (viewCountCheckbox) {
                        // console.log("zoro",viewCountCheckbox,subDim[listData.metric_name].view_count.sum);
                        breakdown_count =
                            subDim[listData.metric_name].comment_count.sum +
                            subDim[listData.metric_name].like_count.sum +
                            subDim[listData.metric_name].share_count.sum;
                    } else {
                        // console.log("zoro",viewCountCheckbox,subDim[listData.metric_name].view_count.sum);
                        breakdown_count =
                            subDim[listData.metric_name].view_count.sum +
                            subDim[listData.metric_name].comment_count.sum +
                            subDim[listData.metric_name].like_count.sum +
                            subDim[listData.metric_name].share_count.sum;
                    }
                } else if (listData.metric_name === "unique_user") {
                    breakdown_count = subDim[listData.metric_name][listData.metric_name].value;
                } else if (listData.metric_name === "sentiment") {
                    breakdown_count = parseFloat(advancedNetSentimentMetric(subDim.sentiment.sentiments.group1.group2.buckets).toFixed(2));
                } else {
                    breakdown_count = subDim[listData.metric_name][listData.metric_name].sum;
                }

                // console.log("tesdfsdafs", listData.dimension_name, dim1.key);
                // if (listData.dimension_name === "entity_sub_type" && dim1.key !== "Unknown")
                // unsorted_dimension2.push({
                //     name: main_dimension,
                //     dimension_id: dimensionId,
                //     breakdown_dimension_id: breakdownDimensionId,
                //     main_breakdown_dimension: mainBreakdown_dimension,
                //     y: breakdown_count,
                // });

                unsorted_dimension2.forEach((ele) => {
                    if (ele.breakdown_dimension_id == breakdownDimensionId && ele.dimension_id == dimensionId) {
                        ele.y = breakdown_count;
                        ele.name = main_dimension;
                        ele.main_breakdown_dimension = mainBreakdown_dimension;
                    }
                });
            });
        } else if (listData.dimension_name === "sentiments") {
            dim1[listData.breakdown_dimension_name][listData.breakdown_dimension_name].buckets.forEach((subDim, subDim_ind) => {
                let main_dimension;
                let main_breakdown_dimension;
                let publishBreakId;

                main_dimension = toTitleCase(dim1.key);
                dimensionId = dim1.key;

                switch (listData.breakdown_dimension_name) {
                    case "published_date":
                        // main_breakdown_dimension = subDim.key_as_string;
                        main_breakdown_dimension = moment(subDim.key_as_string).format("YYYY-MM-DD");
                        breakdownDimensionId = subDim.key;
                        publishBreakId = subDim.key_as_string;
                        break;
                    case "post_types":
                        main_breakdown_dimension = post_types_names[subDim.key];
                        breakdownDimensionId = subDim.key;
                        break;

                    case "entity_sub_type":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownDimensionId = subDim.key;
                        break;

                    case "entity_types":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownDimensionId = subDim.key;
                        break;

                    case "product_attributes": {
                        let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === subDim.key);
                        main_breakdown_dimension = ProductAttributesName[0]?.attributeName || subDim.key;
                        breakdownDimensionId = subDim.key;
                        break;
                    }
                    case "moments":
                        breakdownDimensionId = JSON.parse(JSON.stringify(subDim.key));
                        main_breakdown_dimension = momentsMeta.find((elem) => elem.id === breakdownDimensionId)?.name || breakdownDimensionId;
                        breakdownDimensionId = subDim.key;
                        break;

                    case "top_influencers":
                        main_breakdown_dimension = subDim.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            ? subDim.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            : subDim.key;
                        breakdownDimensionId = JSON.parse(JSON.stringify(subDim.key));
                        break;

                    default:
                        main_breakdown_dimension = subDim.key;
                        breakdownDimensionId = subDim.key;
                }

                let breakdown_count;
                if (listData.metric_name === "mention") {
                    breakdown_count = subDim.doc_count;
                } else if (listData.metric_name === "enagagment_value") {
                    if (viewCountCheckbox) {
                        // console.log("zoro",viewCountCheckbox,subDim.view_count.sum);
                        breakdown_count = subDim.comment_count.sum + subDim.like_count.sum + subDim.share_count.sum;
                    } else {
                        // console.log("zoro",viewCountCheckbox,subDim.view_count.sum);
                        breakdown_count = subDim.view_count.sum + subDim.comment_count.sum + subDim.like_count.sum + subDim.share_count.sum;
                    }
                } else if (listData.metric_name === "unique_user") {
                    breakdown_count = subDim[listData.metric_name].value;
                } else if (listData.metric_name === "sentiment") {
                    breakdown_count = parseFloat(advancedNetSentimentMetric(subDim.sentiments.group1.group2.buckets).toFixed(2));
                } else {
                    breakdown_count = subDim[listData.metric_name].sum;
                }
                // if (listData.breakdown_dimension_name === "entity_sub_type" && subDim.key !== "unknown")

                unsorted_dimension2.forEach((ele) => {
                    if (ele.breakdown_dimension_id == breakdownDimensionId && ele.dimension_id == dimensionId) {
                        ele.breakdown_dimension_id = publishBreakId ? publishBreakId : breakdownDimensionId;
                        ele.y = breakdown_count;
                        ele.name = main_dimension;
                        ele.main_breakdown_dimension = main_breakdown_dimension;
                    }
                });
            });
        } else {
            dim1[listData.breakdown_dimension_name].buckets.forEach((subDim, subDim_ind) => {
                let main_dimension;
                let main_breakdown_dimension;
                let publishBreakId;

                switch (listData.dimension_name) {
                    case "published_date":
                        // main_dimension = dim1.key_as_string;
                        main_dimension = moment(dim1.key_as_string).format("YYYY-MM-DD");
                        dimensionId = dim1.key;
                        break;
                    case "post_types":
                        main_dimension = post_types_names[dim1.key];
                        dimensionId = dim1.key;
                        break;

                    case "entity_sub_type":
                        main_dimension = toTitleCase(dim1.key);
                        dimensionId = dim1.key;
                        break;

                    case "entity_types":
                        main_dimension = toTitleCase(dim1.key);
                        dimensionId = dim1.key;
                        break;

                    case "product_attributes": {
                        let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === dim1.key);
                        main_dimension = ProductAttributesName[0]?.attributeName || dim1.key;
                        dimensionId = dim1.key;
                        break;
                    }

                    case "moments":
                        dimensionId = JSON.parse(JSON.stringify(dim1.key));
                        main_dimension = momentsMeta.find((elem) => elem.id === dimensionId)?.name || dimensionId;

                        break;

                    case "top_influencers":
                        main_dimension = dim1.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            ? dim1.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            : dim1.key;
                        dimensionId = JSON.parse(JSON.stringify(dim1.key));
                        break;

                    default:
                        main_dimension = toTitleCase(dim1.key);
                        dimensionId = dim1.key;
                }

                switch (listData.breakdown_dimension_name) {
                    case "published_date":
                        // main_breakdown_dimension = subDim.key_as_string;
                        main_breakdown_dimension = moment(subDim.key_as_string).format("YYYY-MM-DD");
                        breakdownDimensionId = subDim.key;
                        publishBreakId = subDim.key_as_string;
                        break;
                    case "post_types":
                        main_breakdown_dimension = post_types_names[subDim.key];
                        breakdownDimensionId = subDim.key;
                        break;
                    case "entity_sub_type":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownDimensionId = JSON.parse(JSON.stringify(subDim.key));
                        break;

                    case "entity_types":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownDimensionId = JSON.parse(JSON.stringify(subDim.key));
                        break;

                    case "product_attributes": {
                        let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === subDim.key);
                        main_breakdown_dimension = ProductAttributesName[0]?.attributeName || subDim.key;
                        breakdownDimensionId = JSON.parse(JSON.stringify(subDim.key));
                        break;
                    }

                    case "moments":
                        breakdownDimensionId = JSON.parse(JSON.stringify(subDim.key));
                        main_breakdown_dimension = momentsMeta.find((elem) => elem.id === breakdownDimensionId)?.name || breakdownDimensionId;
                        break;

                    case "top_influencers":
                        main_breakdown_dimension = subDim.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            ? subDim.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            : subDim.key;
                        breakdownDimensionId = JSON.parse(JSON.stringify(subDim.key));
                        break;

                    default:
                        main_breakdown_dimension = subDim.key;
                        breakdownDimensionId = subDim.key;
                }

                let breakdown_count;
                if (listData.metric_name === "mention") {
                    breakdown_count = subDim.doc_count;
                } else if (listData.metric_name === "enagagment_value") {
                    if (viewCountCheckbox) {
                        // console.log("zoro",viewCountCheckbox,subDim.view_count.sum);
                        breakdown_count = subDim.comment_count.sum + subDim.like_count.sum + subDim.share_count.sum;
                    } else {
                        // console.log("zoro",viewCountCheckbox,subDim.view_count.sum);
                        breakdown_count = subDim.view_count.sum + subDim.comment_count.sum + subDim.like_count.sum + subDim.share_count.sum;
                    }
                } else if (listData.metric_name === "unique_user") {
                    breakdown_count = subDim[listData.metric_name].value;
                } else if (listData.metric_name === "sentiment") {
                    breakdown_count = parseFloat(advancedNetSentimentMetric(subDim.sentiments.group1.group2.buckets).toFixed(2));
                } else {
                    breakdown_count = subDim[listData.metric_name].sum;
                }

                // if (listData.breakdown_dimension_name === "entity_sub_type" && subDim.key !== "unknown") this is breaking for 2x2 charts with dimension ===entity_sub_type
                // unsorted_dimension2.push({
                //     name: main_dimension,
                //     dimension_id: dimensionId,
                //     breakdown_dimension_id: breakdownDimensionId,
                //     main_breakdown_dimension: main_breakdown_dimension,
                //     y: breakdown_count,
                // });
                unsorted_dimension2.forEach((ele) => {
                    if (ele.breakdown_dimension_id == breakdownDimensionId && ele.dimension_id == dimensionId) {
                        ele.breakdown_dimension_id = publishBreakId ? publishBreakId : breakdownDimensionId;
                        ele.y = breakdown_count;
                        ele.name = main_dimension;
                        ele.main_breakdown_dimension = main_breakdown_dimension;
                    }
                });
                // totalDataCount += unsorted_dimension2.y;
            });
        }
    });

    const transformed_dimension2 = [];
    unsorted_dimension2.sort((a, b) => b.breakdown_count - a.breakdown_count);
    const allowedValues = ["Person", "Non-person", "Male", "Female", "Brand", "News", "person", "non-person", "male", "female", "brand", "news"]; //Unknown
    // console.log("unsorted_dimension2 2134323", JSON.parse(JSON.stringify(unsorted_dimension2)));
    if (listData.breakdown_dimension_name === "entity_sub_type" || listData.breakdown_dimension_name === "entity_types")
        unsorted_dimension2 = unsorted_dimension2.filter((obj) => {
            // return allowedValues.includes(obj.main_breakdown_dimension)}
            if (allowedValues.includes(obj.main_breakdown_dimension)) return true;
            return false;
        });

    // console.log("unsorted_dimension2 33333", JSON.parse(JSON.stringify(unsorted_dimension2)));

    unsorted_dimension2.forEach((topic) => {
        const existingTopic = transformed_dimension2.find((item) => item.main_breakdown_dimension === topic.main_breakdown_dimension);
        let color, id1, id2;
        if (idData) {
            let reqObject = idData.find((obj) => obj.name === topic.main_breakdown_dimension);
            id1 = reqObject?.id;
        } else if (listData.breakdown_dimension_name === "post_types") {
            id1 = topic.breakdown_dimension_id;
        } else {
            id1 = topic.breakdown_dimension_id;
        }
        if (idData_dimension) {
            let reqObject = idData_dimension.find((obj) => obj.name === topic.name);
            id2 = reqObject?.id;
        } else if (listData.dimension_name === "post_types") {
            id2 = topic.dimension_id;
        } else if (listData.dimension_name === "published_date") {
            if (moment(paramsData.start_date).isAfter(moment(topic.dimension_id).tz(tz).format("YYYY-MM-DDTHH:mm:ss")))
                id2 = getCorrectedDate(paramsData, topic.dimension_id);
            else id2 = topic.dimension_id;
        } else {
            id2 = topic.dimension_id;
        }

        switch (listData.breakdown_dimension_name) {
            case "sentiments":
                color = getSentimentColor(topic.main_breakdown_dimension.toLowerCase());
                break;

            case "platforms":
                color = getPlatformColorCode(topic.main_breakdown_dimension);
                break;

            case "entity_sub_type":
                color = getEntityColor(topic.main_breakdown_dimension.toLowerCase());
                break;

            case "entity_types":
                color = getEntityColor(topic.main_breakdown_dimension.toLowerCase());
                break;
            case "published_date":
                color = intToRGB(hashCode(moment(topic.breakdown_dimension_id).format()));
                break;

            default:
                color = intToRGB(hashCode(topic.main_breakdown_dimension));
        }

        let formattedMetricsName = metricsNameObj[listData?.metric_name] || listData?.metric_name;
        let formattedBreakdownDimensionName = dimensionNameObj[listData.breakdown_dimension_name] || listData.breakdown_dimension_name;
        if (existingTopic) {
            existingTopic.data.push({
                name: topic.name,
                y: topic.y,
                yAxisName: formattedMetricsName, //listData?.metric_name,
                dimensionName: listData?.dimension_name,
                dataId: id2,
                breakdownDimensionName: formattedBreakdownDimensionName, // listData.breakdown_dimension_name,
                breakDownId: id1 ? id1 : topic.main_breakdown_dimension,
                breakDownName: topic.main_breakdown_dimension,
            });
            totalDataCount += topic.y || 0;
        } else {
            transformed_dimension2.push({
                main_breakdown_dimension: topic.main_breakdown_dimension,
                color: color,
                dataId: id1,

                data: [
                    {
                        name: topic.name,
                        y: topic.y || 0,
                        yAxisName: formattedMetricsName, // listData?.metric_name,
                        dimensionName: listData?.dimension_name,
                        dataId: id2,
                        breakDownId: id1 ? id1 : topic.main_breakdown_dimension,
                        breakdownDimensionName: formattedBreakdownDimensionName,
                        breakDownName: topic.main_breakdown_dimension, //listData.breakdown_dimension_name,
                        // breakDownId:id1
                    },
                ],
            });
            totalDataCount += topic.y || 0;
        }
    });

    transformed_dimension2.forEach((ele) => {
        ele.name = ele.main_breakdown_dimension;
        delete ele.main_breakdown_dimension;
    });

    let updatedData = [];
    updatedData = transformed_dimension2.filter((item) => item.name !== "");
    // let updatedData = [];
    // updatedData = [...updatedData, ...transformed_dimension2];
    // updatedData.forEach((ele) => {
    //     ele["name"] = ele["main_breakdown_dimension"];
    //     delete ele["main_breakdown_dimension"];
    // });
    // console.log("xyzLast", updatedData);
    let lineData = [];
    if (listData.dimension_name === "published_date") {
        let result = format2D2MLineChartData(
            metric,
            metric,
            listData.dimension_name,
            listData.breakdown_dimension_name,
            listData.metric_name,
            paramsData,
            viewCountCheckbox,
            momentsMeta,
            ProductAttributes,
            idData,
            post_types_names,
        );

        lineData = result;
    }
    console.log("firstlinnnedata", lineData);
    let validateNoDataCount = totalDataCount;
    return { updatedData, validateNoDataCount, lineData };
};

const advancedNetSentimentMetric = (elements) => {
    let totalData = 0;
    let totalPositive = 0;
    let totalNegative = 0;
    elements.forEach((ele) => {
        if (ele.key == "positive") {
            totalPositive += ele.doc_count;
        } else if (ele.key == "negative") {
            totalNegative += ele.doc_count;
        }

        totalData += ele.doc_count;
    });
    let netSentimentPercentage = ((totalPositive - totalNegative) / totalData) * 100;
    if (elements.length == 0) {
        netSentimentPercentage = 0;
    }
    return netSentimentPercentage;
};

const format2D2MLineChartData = (
    responseData,
    dimension1,
    dimensionName,
    breakdownDimensionName,
    metricName,
    params,
    viewCountCheckbox,
    momentsMeta,
    ProductAttributes,
    idData,
    post_types_names,
) => {
    console.log("response", responseData, metricName);
    let res = {};
    res.nodata = false;

    let dimension2_data = [];
    let master_dimension2 = [];
    let key_dimension2 = [];
    let unique_dimension2 = [];
    let totalData = 0;

    dimension1.forEach((ele, g) => {
        dimension2_data[g] =
            breakdownDimensionName == "sentiments"
                ? ele[breakdownDimensionName].group1.group2.buckets
                : dimensionName === "sentiments"
                ? ele[breakdownDimensionName][breakdownDimensionName].buckets
                : ele[breakdownDimensionName].buckets;
    });

    master_dimension2 = dimension2_data.flatMap((array) => array);

    master_dimension2.forEach((item, i) => {
        key_dimension2[i] = item.key;
    });

    unique_dimension2 = [...new Set(key_dimension2)];
    console.log("response_unique", unique_dimension2);
    res.chartData = {
        date: {
            start_date: "",
            end_date: "",
        },
    };
    let arrays = {};
    unique_dimension2.forEach((ele) => {
        arrays[ele] = new Array(responseData.length).fill(0);
        res.chartData[ele] = [];
    });

    console.log("response_arrays", arrays, res.chartData);
    res.xs = [];
    res.data = arrays;

    responseData.forEach((ele, ind) => {
        res.xs.push(ele.key);
        let arrayObject = ele.sentiments?.group1?.group2?.buckets ? ele.sentiments?.group1?.group2?.buckets : ele[breakdownDimensionName].buckets;
        arrayObject.forEach((item) => {
            let breakdownCount;
            if (metricName === "mention") {
                breakdownCount = item.doc_count;
            } else if (metricName === "enagagment_value") {
                if (viewCountCheckbox) {
                    breakdownCount = item[metricName]
                        ? item[metricName].comment_count.sum + item[metricName].like_count.sum + item[metricName].share_count.sum
                        : item.comment_count.sum + item.like_count.sum + item.share_count.sum;
                } else {
                    breakdownCount = item[metricName]
                        ? item[metricName].view_count.sum +
                          item[metricName].comment_count.sum +
                          item[metricName].like_count.sum +
                          item[metricName].share_count.sum
                        : item.view_count.sum + item.comment_count.sum + item.like_count.sum + item.share_count.sum;
                }
            } else if (metricName === "unique_user") {
                breakdownCount = item[metricName][metricName] ? item[metricName][metricName].value : item[metricName].value;
            } else if (metricName === "sentiment") {
                breakdownCount = parseFloat(
                    advancedNetSentimentMetric(
                        item.sentiment ? item.sentiment.sentiments.group1.group2.buckets : item.sentiments.group1.group2.buckets,
                    ).toFixed(2),
                );
            } else {
                breakdownCount = item[metricName][metricName]?.sum ? item[metricName][metricName]?.sum : item[metricName]?.sum;
            }
            res.data[item.key][ind] = breakdownCount;
            totalData += breakdownCount;
        });
    });

    res.xs.forEach((data, ind) => {
        Object.keys(res.data).forEach((x) => {
            if (!res.data[x][ind]) {
                res.data[x][ind] = 0;
            }
        });
    });

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    if (totalData > 0) {
        Object.keys(res.data).forEach((x) => {
            res.data[x].forEach((d, i) => {
                let date = res.xs[i];
                if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
                console.log("result_loop", x, d, date);
                let breakdownId, main_breakdown_dimension, id1;
                switch (breakdownDimensionName) {
                    case "post_types":
                        main_breakdown_dimension = post_types_names[x];
                        breakdownId = JSON.parse(JSON.stringify(x));
                        break;

                    case "entity_sub_type":
                        main_breakdown_dimension = toTitleCase(x);
                        breakdownId = JSON.parse(JSON.stringify(x));
                        break;

                    case "entity_types":
                        main_breakdown_dimension = toTitleCase(x);
                        breakdownId = JSON.parse(JSON.stringify(x));
                        break;

                    case "moments":
                        breakdownId = JSON.parse(JSON.stringify(x));
                        main_breakdown_dimension = momentsMeta.find((elem) => elem.id == breakdownId).name;
                        break;

                    case "sentiments":
                        breakdownId = JSON.parse(JSON.stringify(x));
                        main_breakdown_dimension = toTitleCase(x);
                        break;

                    case "product_attributes": {
                        let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === x);
                        main_breakdown_dimension = ProductAttributesName[0]?.attributeName || x;
                        breakdownId = JSON.parse(JSON.stringify(x));
                        break;
                    }

                    default:
                        main_breakdown_dimension = x;
                        breakdownId = JSON.parse(JSON.stringify(x));
                }

                if (idData) {
                    let reqObject = idData.find((obj) => obj.name === main_breakdown_dimension);
                    id1 = reqObject?.id;
                } else {
                    id1 = breakdownId;
                }

                let color;
                switch (breakdownDimensionName) {
                    case "sentiments":
                        color = getSentimentColor(main_breakdown_dimension.toLowerCase());
                        break;

                    case "platforms":
                        color = getPlatformColorCode(main_breakdown_dimension);
                        break;

                    case "entity_sub_type":
                        color = getEntityColor(main_breakdown_dimension.toLowerCase());
                        break;

                    case "entity_types":
                        color = getEntityColor(main_breakdown_dimension.toLowerCase());
                        break;

                    default:
                        color = intToRGB(hashCode(main_breakdown_dimension));
                }
                let formattedMetricsName = metricsNameObj[metricName] || metricName;
                date = res.chartData[x].push({
                    x: date,
                    y: d,
                    metricName: metricName,
                    yAxisName: formattedMetricsName,
                    dataId: date,
                    dimensionName: dimensionName,
                    breakdownDimensionName: dimensionNameObj[breakdownDimensionName] || breakdownDimensionName,

                    color: color,

                    breakDownId: id1 ? id1 : main_breakdown_dimension,
                    breakDownName: main_breakdown_dimension,
                });
            });
        });
    } else res.nodata = true;
    res.chartData.date.start_date = params.start_date;
    res.chartData.date.end_date = params.end_date;

    const allowedValues = ["Person", "Non-person", "Male", "Female", "Brand", "News", "person", "non-person", "male", "female", "brand", "news", "date"]; //Unknown

    if (breakdownDimensionName === "entity_sub_type" || breakdownDimensionName === "entity_types") {
        res.chartData = Object.fromEntries(
            Object.entries(res.chartData).filter((obj) => {
                if (allowedValues.includes(obj[0])) return true;
                return false;
            }),
        );
    }

    res.chartData = Object.fromEntries(
        Object.entries(res.chartData).filter((obj) => {
            if (obj[0] == "") return false;
            return true;
        }),
    );

    console.log("response", res);

    return res;
};
